module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/en_hokkaido-008b06c7fd8e617a72adc9bd40260a6d.jpg";